export default function registerServiceWorker() {
  return new Promise((resolve, reject) => {
    const swDisabled =
      process.env.REACT_APP_DISABLE_SW &&
      process.env.REACT_APP_DISABLE_SW.toLowerCase() === 'true';

    if (navigator.serviceWorker && !swDisabled) {
      window.addEventListener('load', () => {
        return navigator.serviceWorker
          .register('/sw.js')
          .then(resolve)
          .catch(reject);
      });
    } else {
      // unregister existing service workers for better dev experience
      if (navigator.serviceWorker) {
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => {
            registrations.forEach((registration) => registration.unregister());
          })
          .catch(reject);
      }

      const rejectionReason = swDisabled
        ? 'Service worker disabled'
        : 'Service worker not supported';

      return reject(rejectionReason);
    }
  });
}
